// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleBody_root__17rER"};